import { Flex } from '@mantine/core';
import StatCard from '@/components/StatCard.tsx';
import { useMemo } from 'react';
import { ExecutionStatus } from '@/types/statuses.ts';
import { Automation } from '@/types/automations.ts';

export type AutomationFilter = 'All' | 'Completed' | 'Failed';

type props = {
  automations: Automation[];
  automationFilter: AutomationFilter;
  setAutomationFilter: (filter: AutomationFilter) => void;
};

const AutomationStats = ({ automations, automationFilter, setAutomationFilter }: props) => {
  const automationCounts = useMemo(() => {
    const total = automations.length;
    const completed = automations.filter(
      (a) => a.latest_run_status === ExecutionStatus.Completed,
    ).length;
    const failed = automations.filter((a) => a.latest_run_status === ExecutionStatus.Errors).length;
    return [total, completed, failed];
  }, [automations]);

  const onCardClick = (filter: AutomationFilter) => {
    setAutomationFilter(filter === automationFilter ? 'All' : filter);
  };

  return (
    <Flex gap={'sm'} w={'100%'} mt={'xl'}>
      <StatCard
        title="All"
        value={automationCounts[0]}
        active={automationFilter === 'All'}
        onClick={() => onCardClick('All')}
      />
      <StatCard
        title="Completed"
        value={automationCounts[1]}
        active={automationFilter === 'Completed'}
        onClick={() => onCardClick('Completed')}
      />
      <StatCard
        title="Failed"
        value={automationCounts[2]}
        active={automationFilter === 'Failed'}
        onClick={() => onCardClick('Failed')}
      />
    </Flex>
  );
};

export default AutomationStats;
